import { ISideMenuLang } from '../../../types/lang'

export const sideMenuLang: ISideMenuLang = {
	side_menu: {
		affiliate_title: 'Affiliate',
		offer_scope_title: 'Tracking Cap',
		offer_spend_title: 'Offer Spend',
		offer_spend_report_title: 'Report Offer Spend',
		offer_spend_report_by_account_title: 'By Account',
		offer_spend_report_by_offer_title: 'By Offer',
		offer_spend_report_by_offer_scope_title: 'By Offer Scope',
		postback_send_title: 'Send Postback',
		revenue_agency_title: 'Agency',
		revenue_spend_title: 'Spend',
		revenue_spend_report_by_account_title: 'ROI By User',
		revenue_spend_report_by_team_title: 'ROI By Team',
		account_title: 'Accounts',
		role_title: 'Roles',
		job_title: 'Jobs',
		project_title: 'Projects',
		login_title: 'Login',
		logout_title: 'Logout',
	}
}